<template>
  <v-app id="app" class="minimart">
    <component
      :is="$route.meta.layout || 'div'"
      @hook:created="$emit('created', $route.meta.layout)"
    >
      <ShopErrorView v-if="getShopFetchError" />
      <router-view v-else :key="$route.fullPath" />
    </component>

    <Dialogs />
    <Snackbars />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopErrorView from '@/views/ShopErrorView'
import Dialogs from '@/components/Dialogs'
import Snackbars from '@/components/Snackbars'

export default {
  name: 'App',
  components: {
    ShopErrorView,
    Dialogs,
    Snackbars,
  },
  meta() {
    return {
      title: this.getShopTitle,
      meta: [
        {
          name: 'description',
          content: `Online Ordering for ${this.getShopTitle}`,
        },
      ],
    }
  },
  data: () => ({
    //
  }),

  computed: {
    ...mapGetters('shop', [
      'getIsShopLoading',
      'getShopFetchError',
      'getShopTitle',
      'getIsBakeSale',
    ]),
    isShopLoading() {
      return this.getIsShopLoading
    }, // isShopLoading
  },
}
</script>

<style lang="scss">
.caslon--font {
  font-family: williams-caslon-text, serif;
}

#app {
  @extend .caslon--font;
  font-weight: 700;
}

.proxima--font {
  font-family: proxima-nova, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.proxima-medium--font {
  font-family: proxima-nova, sans-serif;
  font-weight: 600 !important;
  font-style: normal;
}
.proxima-bold--font {
  font-family: proxima-nova, sans-serif;
  font-weight: 700 !important;
  font-style: normal;
}

.v-btn:not(.caslon--font) {
  @extend .proxima--font;
  &.v-btn--outlined {
    @extend .proxima-medium--font;
  }
}

.v-chip {
  @extend .proxima--font;
}

h1,
h2,
h3 {
  word-break: break-word;
}
.minimart .v-card__title {
  line-height: 1;
}
.email-link {
  display: inline-block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: opacity 0.2s;
}
.fade-fast-enter, .fade-fast-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-popper__wrapper {
  max-width: 600px;
}
</style>
